var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-tab',{ref:"tab",staticClass:"p-0",attrs:{"title":"Membership","lazy":""}},[_c('membership-information')],1)}
var staticRenderFns = []

export { render, staticRenderFns }